import React from "react"

const Intro = () => {
  return (
    <div className="intro">
      <div className="header-update"></div>
      <div className="content video-container">
        {/* <strong className="logo-content">EQUALITYNOW</strong> */}
        <div className="text-wrap-header">
          <div className="margin-top-bottom">
            <div className="text">
              <h1>
                <img src="./figheadline2.png" />
                Equality Now’s Virtual Global Gala
                <br />
                Aired on October 12, 2021. Watch any time below!
              </h1>
            </div>
          </div>
        </div>
        <div className="video-box-outer">
          <div className="video-box-2">
            <div className="video-inner">
              {/* <iframe
                title="Live"
                className="video-2"
                src="https://vimeo.com/event/1369022/embed/bdf5d25a40"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
              ></iframe> */}
              {/* <iframe
                className="video-2"
                src="https://www.youtube.com/embed/hK_bnfpVu_I"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              /> */}
              <iframe
                className="video-2"
                src="https://www.youtube.com/embed/hK_bnfpVu_I"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            </div>

            <div className="text-box">
              <p>
                If you’re experiencing issues with the video player, please 1)
                close all unnecessary tabs, and 2) refresh your browser. The
                recording of the show will be available shortly after the live
                show ends. For help troubleshooting, please email{" "}
                <a className="link" href="mailto:events@equalitynow.org">
                  events@equalitynow.org
                </a>
              </p>
            </div>
          </div>

          <div className="widget">
            <div className="head-text">
              <strong className="logo">
                <a href="https://www.equalitynow.org/">Equality Now</a>
              </strong>
            </div>
            <div className="hold-box">
              <div
                id="give-lively-widget"
                className="gl-simple-donation-widget"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div className="intro-outer">
        <div className="intro-text">
          <div className="text-wrap-header">
            <div className="text">
              <div className="content gala-info-header">
                <h1>Join us to celebrate International Day of the Girl</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="idgc-container">
          <img className="idgc-image" src="./IDGC-logo.png" />
        </div>
        <div className="content intro-text-inner">
          <p>
            Equality Now’s annual Make Equality Reality Gala is a unique
            celebration of arts, advocacy, and entertainment that inspires
            activism and celebrates those advocating for women and girls’
            rights.
          </p>
          <p>
            This year’s event coincides with Equality Now’s campaign around
            International Day of the Girl to raise funds and awareness of our
            work on behalf of girls around the world. This crucial support
            enables our team of human rights lawyers to use the law to protect
            and promote the rights of women and girls.
          </p>
          <p>
            Thank you for being part of this movement. Together, we can create a
            just world with enduring equality for women and girls.
          </p>
          <p>
            Please join us by making a gift for women and girls everywhere.
            Gifts made this week will be doubled - so your support will go twice
            as far!{" "}
            <a className="link" href="https://www.equalitynow.org/donate">
              Head to our website to donate now.
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Intro
